import React, {useEffect, useState, useMemo } from 'react';
import { AreasAdapter, Area } from '../../../../../../infraestructure/persistence/rest/AreasAdapter';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import {ListadoAreasScreen} from './screen';

export const ListaAreasContainer = (props:any) => {
	
	const {dn, onSavePermisos, permissions} = props
	const api = new AreasAdapter();
	const { exceptionError, resultError, launchNotification } = useNotifications();
	let [data, setData] = useState<any>([]);
	let result: any;

	useEffect(()=> {if(dn!==undefined) getAreasDn(dn)},[dn])

	const getAreasDn = async (idDN:any) => {
		try {
			result = await api.ListarAreasPermisos(idDN);
			if(result.data && result.data!=="")
			{
				setData([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  	};

	const getPermissionsDn = useMemo(()=> permissions.filter((f:any)=> f.idDN===dn),[dn,permissions]);

	const getData = useMemo(()=> {return {...{},...{areas:data,permissions:getPermissionsDn}}},[data,permissions])

	return dn!==undefined ? <ListadoAreasScreen data={getData} onSavePermisos={onSavePermisos}/> : null
};

export default ListaAreasContainer;